/* @flow */
/*jshint esversion: 6 */
import { Button, Card, Checkbox, Col, Form, Icon, InputNumber, message, Popconfirm, Radio, Row, Select } from "antd";
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import GenericModal from "../../components/GenericModal";
import GenericSelector from "../../components/GenericSelector";
import TableIDs from "../../data/TableIDs";
import { Job, User, OutputType, ProcessType } from '../../JmReact';
import DateTimePicker from "../../components/DateTimePicker";


class SiteBlockedButtonForAutoIphone extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
            methodList: '',
            mSuspendUntil: null,
            mAllowFutureOrder: null,
            mWeeklyBlockDay: null,
            mWeeklyBlockHour: null,
        }

        this.selectors = [
            { id: TableIDs.genericSelectorDeliveryMethods, api: "delivery_methods_list_all" },
        ];

        this.selectors.forEach(x => { if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector } })

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    saveData = () => {
        const { branchId } = this.props
        const { methodList, mSuspendUntil, mAllowFutureOrder, mWeeklyBlockDay, mWeeklyBlockHour } = this.state
        this.sendAPI("save_branch_delivery_method_coto", { branchId, methodList, mSuspendUntil, mAllowFutureOrder, mWeeklyBlockDay, mWeeklyBlockHour }, () => {
            this.setState({ modalOpen: false }, () => { message.success(this.getText(21236)) })
        })
    }

    render() {
        const { modalOpen, methodList, mSuspendUntil, mAllowFutureOrder, mWeeklyBlockDay, mWeeklyBlockHour } = this.state
        const disabled = !methodList || (!mSuspendUntil && !mWeeklyBlockDay)
        return (<div style={{ textAlign: "center", marginBottom: 5, display: 'inline-block', verticalAlign: 'text-top' }}>
            <Button onClick={() => { this.setState({ modalOpen: true }) }}>
                <Icon type={"cloud"} style={{ marginLeft: 5 }} />
                {this.getText(21233)}
            </Button>
            <GenericModal
                visible={modalOpen}
                onCancel={() => { this.setState({ modalOpen: false }) }}
                title={this.getText(21233)}
                width={600}
                footer={[
                    <Button type="primary" onClick={this.saveData} disabled={disabled}>{this.getText(21234)}</Button>,
                    <Button onClick={() => { this.setState({ modalOpen: false }) }}>{this.getText(21235)}</Button>,
                ]}>
                <Form.Item label={this.getText(21238)}>
                    <GenericSelector
                        {...this.props}
                        multi
                        {...this.selectors[0]}
                        value={methodList ? methodList.split(",") : []}
                        onChange={e => { this.setState({ methodList: e ? e.join(",") : "" }) }}
                    />
                </Form.Item>
                <Form.Item label={this.getText(21239)}>
                    <DateTimePicker
                        format={"DD/MM/YYYY HH:mm"}
                        showTime
                        value={mSuspendUntil}
                        onChange={e => { this.setState({ mSuspendUntil: e }) }}
                    />
                </Form.Item>
                <Form.Item>
                    <Checkbox
                        checked={mAllowFutureOrder == "1"}
                        onChange={e => { this.setState({ mAllowFutureOrder: e.target.checked ? "1" : "0" }) }}
                    >{this.getText(21240)}</Checkbox>
                </Form.Item>
                <Form.Item label={this.getText(21241)}>
                    <div>
                        <Select
                            style={{ width: '50%' }}
                            value={mWeeklyBlockDay}
                            onChange={e => { this.setState({ mWeeklyBlockDay: e }) }}
                        >
                            <Select.Option key={'null'} value={''}> - </Select.Option>
                            {[
                                { day: '1', text: 17208 },
                                { day: '2', text: 17209 },
                                { day: '3', text: 17210 },
                                { day: '4', text: 17211 },
                                { day: '5', text: 17212 },
                                { day: '6', text: 17213 },
                                { day: '7', text: 17214 },
                            ].map(x => (<Select.Option key={x.day} value={x.day}>{this.getText(x.text)}</Select.Option>))}
                        </Select>
                        <DateTimePicker 
                        format="HH:mm:ss" 
                        style={{ width: '50%' }} 
                        value={mWeeklyBlockHour}
                        onChange={e => { this.setState({ mWeeklyBlockHour: e }) }}
                    />
                    </div>
                </Form.Item>
            </GenericModal>
        </div>)
    }
}

export default SiteBlockedButtonForAutoIphone;